import React, { useEffect } from 'react';

import styled from 'styled-components';

import {
  EForgotPasswordContent,
  forgotPasswordViewController,
  useForgotPassword
} from '@aqx-core/common/services/forgot-password';

import ForgotPasswordComplete from './content/completed';
import ForgotPasswordForm from './content/form';

export interface IForgotPasswordScreen {
  isCRM?: boolean;
}

const ForgotPasswordScreen: FCC<IForgotPasswordScreen> = ({ isCRM = false }) => {
  const { content } = useForgotPassword();

  useEffect(() => {
    return () => {
      forgotPasswordViewController.reset();
    };
  }, []);

  return (
    <StyledContainer>
      {content === EForgotPasswordContent.FORM ? <ForgotPasswordForm isCRM={isCRM} /> : <ForgotPasswordComplete />}
    </StyledContainer>
  );
};

export default ForgotPasswordScreen;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
